export const setThemeBackground = (isWhite: boolean) =>
  isWhite ? "background-colour-white" : "background-colour-black";

export const setThemeColour = (isWhite: boolean) =>
  isWhite ? "colour-white" : "colour-black";
